import {
    formatDateToYYYYMM, formatDateToYYYYMMDD, formatDateToYYYYMMDDHH, formatDateToYYYYMMDDHHMM,
} from '../../core/utils/formatters';
import { GROUPED_BY_DAY, GROUPED_BY_HOUR, GROUPED_BY_MINUTE, GROUPED_BY_MONTH } from '../constants/charts';

export const groupData = (data, groupedBy) => {
    let groupedData = {};
    groupedData = data.reduce((acc, item) => {
        let timestamp;
        const date = new Date(item.timestamp);

        switch (groupedBy) {
            case GROUPED_BY_MINUTE:
                timestamp = formatDateToYYYYMMDDHHMM(date);
                break;
            case GROUPED_BY_HOUR:
                date.setMinutes(0, 0, 0);
                timestamp = formatDateToYYYYMMDDHH(date);
                break;
            case GROUPED_BY_DAY:
                timestamp = formatDateToYYYYMMDD(date);
                break;
            case GROUPED_BY_MONTH:
                date.setDate(1);
                date.setHours(0, 0, 0, 0);
                timestamp = formatDateToYYYYMM(date);
                break;
            default:
                return acc;
        }

        const inflow = item.inflow || 0;
        const outflow = item.outflow || 0;
        const waitingUsers = item.waitingUsers || 0;
        const instantProcessed = item.instantProcessed || 0;
        const maxOutflow = item.maxOutflow || 0;
        if (inflow === 0 && outflow === 0 && waitingUsers === 0 && instantProcessed === 0 && maxOutflow === 0) {
            return acc;
        }

        if (!acc[timestamp]) {
            acc[timestamp] = { inflow, outflow, waitingUsers, instantProcessed, maxOutflow };
        } else {
            acc[timestamp].inflow += inflow;
            acc[timestamp].outflow += outflow;
            acc[timestamp].waitingUsers = Math.max(acc[timestamp].waitingUsers, waitingUsers);
            acc[timestamp].instantProcessed += instantProcessed;
            acc[timestamp].maxOutflow = Math.max(acc[timestamp].maxOutflow, maxOutflow);
        }

        return acc;
    }, {});

    return groupedData;
};

export default groupData;
